<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-slider">
    <cs-label>cs-slider (value {{ sliderValue }})</cs-label>
    <cs-slider [min]="0" [max]="100" [step]="5" [(value)]="sliderValue" [tickmarks]="sliderTickmarks"></cs-slider>
  </div>

  <div class="showcase-row" data-showcase-id="cs-roller">
    <cs-label>cs-roller (index {{ rollerIndex }})</cs-label>
    <cs-roller [dataProvider]="rollerData" [(currentIndex)]="rollerIndex"></cs-roller>
  </div>

  <div class="showcase-row" data-showcase-id="cs-date-button-bar">
    <cs-label>cs-date-button-bar</cs-label>
    <cs-date-button-bar [(selectedDays)]="trainingDays"></cs-date-button-bar>
  </div>

  <div class="showcase-row" data-showcase-id="cs-date-range-toolbar">
    <cs-label>cs-date-range-toolbar</cs-label>
    <cs-date-range-toolbar timePeriod="month"></cs-date-range-toolbar>
  </div>

  <div class="showcase-row" data-showcase-id="cs-calorie-change-input">
    <cs-label>cs-calorie-change-input (base 2178 kcal, lowest target 1632 kcal, value {{ calorieTarget }})</cs-label>
    <cs-calorie-change-input [baseCalories]="2178" [minimumDailyIntake]="1632" [(calories)]="calorieTarget"></cs-calorie-change-input>
  </div>

  <div class="showcase-row" data-showcase-id="cs-next-intake-card">
    <cs-label>cs-next-intake-card, a card of its own (reported 2178 kcal, the app recommends 2069 kcal; the host's radio rows go inside)</cs-label>
    <cs-next-intake-card [nowKcal]="2178" [recommendedKcal]="2069">
      <cs-radio-group [(selected)]="nextIntakePick">
        <cs-radio value="accept">Accept the New Target</cs-radio>
        <cs-radio value="keep">Keep My Current Target</cs-radio>
      </cs-radio-group>
    </cs-next-intake-card>
  </div>

  <div class="showcase-row" data-showcase-id="cs-task-calendar">
    <cs-label>cs-task-calendar, and a lone cs-task-calendar-day</cs-label>
    <cs-task-calendar [taskStatuses]="calendarStatuses" [(selectedDate)]="calendarSelectedDay"></cs-task-calendar>
    <div class="showcase-variants">
      <cs-task-calendar-day [date]="today" [taskStatus]="TaskStatus.Completed" [isToday]="true"></cs-task-calendar-day>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-skinfold-site-measure">
    <cs-label>cs-skinfold-site-measure</cs-label>
    <cs-skinfold-site-measure [siteName]="'Chest' | untranslated" sitePhoto="assets/imgs/Skinfold-M-Chest.svg"
      [(measures)]="skinfoldMeasures"></cs-skinfold-site-measure>
  </div>

  <div class="showcase-row" data-showcase-id="cs-radio-display">
    <cs-label>cs-radio-display</cs-label>
    <cs-radio-display [label]="'Muscle Growth' | untranslated" value="growth"
      [description]="'Read-only row styled like a radio option.' | untranslated"></cs-radio-display>
    <cs-radio-display [label]="'Sets Per Week Per Muscle Group' | untranslated" value="Maximum effort" customText="14 sets">
      <div radioDisplayNote>
        <cs-note light>Current plan: 16 sets/week</cs-note>
        <cs-tooltip small iconType="help" [text]="'The optional radioDisplayNote line under the value.' | untranslated"></cs-tooltip>
      </div>
    </cs-radio-display>
  </div>
</div>
